import React, {Component} from 'react';
import {Button, Layout, Loading, Notification} from 'cria-ui-react';

import './Login.scss';
import logoImg from '../../../assets/originar-sustentabilidade.png';
import VersionService from '../../../services/VersionService';

import * as UsuarioActions from '../../../store/actions/usuarioActions';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import UsuarioService from "../../../services/UsuarioService";
import {login} from '../../../utils';
import {
    BASE_URL,
    REACT_APP_AZURE_CLIENT_ID,
    REACT_APP_AZURE_TENANT_ID,
    REACT_APP_AZURE_URL
} from "../../../services/api";

const mapStateToProps = state => ({
    dadosUsuario: state.usuarioState.dadosUsuario
});

const mapDispatchToProps = dispatch => bindActionCreators(
    Object.assign({}, UsuarioActions), dispatch
);

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            version: null,
            loading: false,
        };
        this.getVersion();
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        if (code) {
            this.props.history.replace('/login');
            this.handleSSOLogin(code);
        }
    }


    handleSSOLogin(code) {
        this.setState({ loading: true });
        const clientUrl = `${window.location.origin}${BASE_URL}login`;
        UsuarioService.login(
            {
                code,
                clientId: REACT_APP_AZURE_CLIENT_ID,
                clientUrl
            }
        )
            .then((response) => {
                this.props.setDadosUsuario(response.data);
                login();
                this.props.history.push('/selecionar-filial');
            })
            .catch(({ response }) => {
                Notification.error({
                    title: 'Não foi possível fazer o login',
                    message: response?.data?.message || 'Erro ao autenticar com conta Amaggi',
                    duration: 8000
                });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    handleRedirectSSO() {
        this.setState({ loading: true });
        const claims = JSON.stringify({
            id_token: {
                amr: {
                    essential: true,
                    values: ["mfa"]
                }
            }
        });
        window.location.href = REACT_APP_AZURE_URL
                .replace('{{tenant_id}}', REACT_APP_AZURE_TENANT_ID)
                .replace('{{client_id}}', REACT_APP_AZURE_CLIENT_ID)
            + `&claims=${encodeURIComponent(claims)}`;
    }

    getVersion() {
        VersionService.getVersion()
            .then(({ data }) => {
                this.setState({ version: data.version });
            });
    }

    render() {
        const { version } = this.state;
        return (
            <Loading loading={this.state.loading} text="Autenticando o usuário e a senha">
                <div className="container">
                    <Layout.Row>
                        <img src={logoImg} className="logo" alt="logotipo da plataforma originar" />
                    </Layout.Row>
                    <Layout.Row className="form-login">
                        <p className="title-login">Bem-vindo</p>
                        <p className="subtitle-login">Clique no botão abaixo para acessar<br/> o sistema</p>
                        <Button
                            className="btn-entrar"
                            type="primary"
                            onClick={() => this.handleRedirectSSO()}
                        >
                            <span className="mdi mdi-login icon-login"></span>
                            Entrar com conta Amaggi
                        </Button>
                    </Layout.Row>
                    <Layout.Row className="footer">
                        <div className="version">
                            © {new Date().getFullYear()} - Plataforma Originar
                            {version && <div className="version-number">{version}</div>}
                        </div>
                    </Layout.Row>
                </div>
            </Loading>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Login);